import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const StatusContent = ({data}) => {

    useEffect(() => {
        const values = [];
        const labels = [];

        data.attendanceStatus?.sort((a, b) => b.qty - a.qty).forEach((item) => {
            labels.push(ReportUtils.formatText(item.status));
            values.push(item.qty);
        });

        ReportUtils.createExportableTable(labels, values, "Status dos atendimentos");
        GraphicUtils.barChart('attendance-status', values.slice(0, 10), labels.slice(0, 10), false);
    }, [data]);

    return (
        <>
            <div className="chart-report duo-bar-chart">
                <div className="chart-title text-center mb-3">Status dos atendimentos {data.attendanceStatus.length >= 10 ? ' (TOP 10)' : ''}</div>
                <div className="chart-report" id="attendance-status"></div>
            </div>
        </>
    );
};

export default StatusContent;